import React from 'react';

import Card from '../Card/Card';
import { Split, Title } from './Cards.styles';

const Cards = ({ cardsData }) => {
  const { mainTitle, cards } = cardsData;

  return (
    <>
      <Title>{mainTitle}</Title>
      <Split>
        {cards.map(card => (
          <Card
            key={card.id}
            title={card.mainTitle}
            subtitle={card.subtitle}
            linkTitle={card.linkTitle}
            image={card.image[0]}
            ctaUrl={card.ctaUrl}
          />
        ))}
      </Split>
    </>
  );
};

export default Cards;
